import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => (_jsx("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", ...props, children: _jsx("path", { d: "m6 6 12 12M18 6 6 18", stroke: "currentColor", strokeWidth: 2.25, strokeLinecap: "round" }) }));
export default SvgClose;
